import secureLocalStorage from "react-secure-storage";
import { toast } from "react-toastify";
import { bpDigitalApi } from "services/api";

export interface IValidaTokenIn {
	trackId: string,
	appId: string | undefined,
	internalToken: string | undefined,
	token: string
}

export interface IValidaTokenOut {
	token: string,
	isAuthenticated: boolean,
	reason: string,
	expiresIn: number,
	tokenType: string
}

export interface IBuscaClienteOut {
  loginType: "CpfCnpj" | "2fa"
	nome: string,
	cpfCnpj?: string,
	internalToken: string,
	emails: string[],
	telefones: string[],

  token?: string,
  isAuthenticated?: boolean,
  reason? : any,
  expiresIn?: number,
  tokenType?: string,
}

export async function buscaCliente(
    cpfCnpj: string | undefined,
    setCliente: (_buscaClienteOut: IBuscaClienteOut) => void
): Promise<IBuscaClienteOut> {
  try {
    const recaptcha = secureLocalStorage.getItem("@grecaptcha") ?? "example";

    const result = await bpDigitalApi.post<IBuscaClienteOut>(
      '/Autenticacao/busca-cliente',
      {
        appId: process.env.REACT_APP_ID,
        appSecret: process.env.REACT_APP_PASS,
        captcha: recaptcha,
        doc: cpfCnpj,
        trackId: "",
      }
    );

    if (result.status === 204) {
      throw new Error("Nenhum cliente encontrado: 204 No Content");
    }

    const cliente = { ...result.data, cpfCnpj: cpfCnpj };

    setCliente(cliente);
    return cliente;

  } catch (error: any) {
    	throw error;
  }
}

export async function enviaToken(
	telefone: string,
	internalToken: string | undefined
) {
	try{
		const appId = process.env.REACT_APP_ID
		const result = await bpDigitalApi.post('/Autenticacao/envia-token', {
			trackId: '',
			appId: appId,
			internalToken: internalToken,
			telefone: telefone
		});
		return result.data

	}
	catch(error:any){
		throw error
	}
}

export async function validaToken(_validaToken: IValidaTokenIn): Promise<IValidaTokenOut | undefined> {
	try {
		const result = await bpDigitalApi.post<IValidaTokenOut>('/Autenticacao/valida-token', _validaToken);
		return result.data;
	} catch (error: any) {
		toast.error(error.response?.data || "Erro ao validar token");
		return undefined;
	}
}

export interface IValidaTrackIdIn {
	appId: string | undefined
	trackId: string | undefined
	cpfCnpj: string | undefined
}
export interface IValidaTrackIdResponse {
	token: string;
	isAuthenticated: boolean;
	reason: string | null;
	expiresIn: number;
	tokenType: string;
}

export async function validaTrackId(_validaTrackIdIn: IValidaTrackIdIn) {
	await bpDigitalApi.post<IValidaTrackIdResponse>('/Autenticacao/valida-trackid', _validaTrackIdIn)
		.then(
			(result) => {
				secureLocalStorage.setItem('@token', result.data.token)
			}
		)
}

export interface IBuscaTrackIdIn {
	AppId: string
	TrackId: string
}
export interface IBuscaTrackIdOut {
	content: IBuscaTrackIdContent
	success: boolean
	msgInsucesso: string
}
export interface IBuscaTrackIdContent {
	nomeCliente: string
	documentoIncompletoCliente: string
}
export async function buscaTrackId(_buscaTrackIdIn: IBuscaTrackIdIn) {
	await bpDigitalApi.post<IBuscaTrackIdOut>('/Autenticacao/busca-trackid', _buscaTrackIdIn)
		.then(
			(result) => {
				localStorage.setItem('@nomeCliente', result.data.content.nomeCliente)
				localStorage.setItem('@documentoIncompletoCliente', result.data.content.documentoIncompletoCliente)
			}
		)
}
